import React, { useState, useEffect } from "react";
import _ from "lodash";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { t } from "i18next";
import axios from "axios";
import "./modal.scss";
import Fileopenmodal from "./fileopenmodal";

const OneDriveLogin = ({
  uuid,
  instanceId,
  setShowOneDrive,
  fetchFolderName,
  type,
  tableUUId,
  referenceId,
  source,
  setShowSharePoint,
  setLoading,
}) => {
  const [rootItems, setRootItems] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [folderContent, setFolderContent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [id, setId] = useState("");
  const [driveId, setDriveId] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const token = Utils.getLocalStorageItem("_t");
  const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
  const fetchOneDriveLogin = async () => {
    const result = {
      oneDrive: false,
      sharepoint: false,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}one-drive/integrationStatus?type=${source}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        }
      );

      const status = response?.data?.data?.status === true;

      if (source === "oneDrive") {
        localStorage.setItem("oneDrive", status.toString());
        result.oneDrive = status;
      } else if (source === "sharepoint") {
        localStorage.setItem("sharepoint", status.toString());
        result.sharepoint = status;
      }
    } catch (error) {
      console.error("Error fetching integration status:", error);
    }

    return result;
  };

  useEffect(() => {
    const init = async () => {
      // 1. Fetch integration status first
      const integrationStatus = await fetchOneDriveLogin();

      const codeSharepoint = localStorage.getItem("codeSharepoint");
      const codeoneDrive = localStorage.getItem("codeoneDrive");

      // 2. Handle token if code present
      if (codeSharepoint) {
        await handleToken(codeSharepoint);
      } else if (codeoneDrive) {
        await handleToken(codeoneDrive);
      }

      // 3. Check source logic
      if (source === "oneDrive") {
        if (integrationStatus.oneDrive === true) {
          await fetchRootItems();
          setShowModal(true); // open modal if already connected
        } else if (!codeoneDrive) {
          localStorage.setItem("uuid", uuid);
          window.location.href = `${process.env.REACT_APP_BASE_URL}auth?orgId=${currentUser?.orgId}&type=oneDrive`;
        }
      } else if (source === "sharepoint") {
        if (integrationStatus.sharepoint === true) {
          await fetchRootItems();
          setShowModal(true);
        } else if (!codeSharepoint) {
          localStorage.setItem("uuid", uuid);
          window.location.href = `${process.env.REACT_APP_BASE_URL}auth?orgId=${currentUser?.orgId}&type=sharepoint`;
        }
      }
    };

    init();
  }, []);

  // Handle OAuth Token
  const handleToken = async (code) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}auth/callback?type=${source}&code=${code}`,
        {
          headers: {
            orgId: currentUser?.orgId,
            "x-access-token": token,
          },
        }
      );

      if (!_.isEmpty(response)) {
        if (source === "oneDrive") {
          localStorage.removeItem("codeoneDrive");
        } else if (source === "sharepoint") {
          localStorage.removeItem("codeSharepoint");
        }

        await fetchRootItems();
        setShowModal(true);
      }
    } catch (error) {
      window.location.reload();
      localStorage.removeItem("codeSharepoint");
      localStorage.removeItem("codeoneDrive");
      console.error(
        "Error exchanging code:",
        error.response?.data || error.message
      );
    }
  };

  // Fetch Root Directory Items
  const fetchRootItems = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}one-drive/root`,
        {
          source: source,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      if (!_.isEmpty(response)) {
        const foldersOnly = response.data.filter((item) => item.folder);
        if (localStorage.getItem("source") === "sharepoint") {
          await setRootItems(response.data);
          setShowModal(true);
          setLoading(false);
        } else {
          await setRootItems(foldersOnly);
          setShowModal(true);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching root items:", error);
    }
  };
  const fetchSharePointSites = async (siteID, skipWebhook = false) => {
    setSelectedFolderId(siteID);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}sharepoint/folder`,
        {
          source: source,
          siteId: siteID,
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      if (!_.isEmpty(response)) {
        const folderData = response.data;
        const foldersOnly = response.data;

        setFolderContent(foldersOnly);
        setEmail(folderData.createdByemail);
        setId(folderData.id);
        setDriveId(folderData.driveId);
        if (!skipWebhook) {
          await registerWebhook(
            folderData.createdBy.email,
            folderData.id,
            folderData.driveId,
            folderData.name
          );
        }

        return foldersOnly;
      }
    } catch (error) {
      console.error("Error fetching SharePoint sites:", error);
    }
  };
  const fetchSharePointFolderChildren = async (
    folderId,
    skipWebhook = false
  ) => {
    setSelectedFolderId(folderId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}sharepoint/children`,
        {
          source: source,
          folderId: folderId,
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (!_.isEmpty(response)) {
        const folderData = response?.data;
        const foldersOnly = response?.data;

        setFolderContent(foldersOnly);
        setEmail(folderData?.createdBy?.user?.email);
        setId(folderData?.parentReference?.id);
        setDriveId(folderData?.parentReference?.driveId);
        if (!skipWebhook) {
          await registerWebhook(
            folderData.createdBy.user.email,
            folderData.parentReference.id,
            folderData.parentReference.driveId,
            folderData.parentReference.name
          );
        }

        return foldersOnly;
      }
    } catch (error) {
      console.error("Error fetching SharePoint folder children:", error);
    }
  };
  const fetchSharePointFolderFiles = async (
    folderId,
    driveId,
    skipWebhook = false
  ) => {
    setSelectedFolderId(folderId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}sharepoint/files`,
        {
          source: source,
          folderId: folderId,
          driveId: driveId,
        },
        {
          headers: {
            "x-access-token": token,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (!_.isEmpty(response)) {
        const folderData = response?.data;
        const foldersOnly = response?.data;
        setFolderContent(foldersOnly);
        setEmail(folderData?.createdBy?.user?.email);
        setId(folderData?.parentReference?.id);
        setDriveId(folderData?.parentReference?.driveId);
        if (!skipWebhook) {
          await registerWebhook(
            folderData.createdBy.user.email,
            folderData.parentReference.id,
            folderData.parentReference.driveId,
            folderData.parentReference.name
          );
        }

        return foldersOnly;
      }
    } catch (error) {
      console.error("Error fetching SharePoint folder children:", error);
    }
  };

  const fetchFolderContent = async (folderId, skipWebhook = false) => {
    setSelectedFolderId(folderId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}one-drive/folder`,
        {
          orgId: currentUser?.orgId,
          folderId: folderId,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      );

      if (!_.isEmpty(response)) {
        const folderData = response.data[0];
        const foldersOnly = response.data.filter((item) => item.folder);
        setFolderContent(foldersOnly);
        setEmail(folderData.createdBy.user.email);
        setId(folderData.parentReference.id);
        setDriveId(folderData.parentReference.driveId);
        if (!skipWebhook) {
          await registerWebhook(
            folderData.createdBy.user.email,
            folderData.parentReference.id,
            folderData.parentReference.driveId,
            folderData.parentReference.name
          );
        }

        return foldersOnly;
      }
    } catch (error) {
      console.error("Error fetching folder content:", error);
    }
  };

  // Register Webhook for Folder Changes
  const registerWebhook = async (userEmail, siteID, driveId, name) => {
    setLoadingData(true);
    setShowModal(false);

    try {
      const payload =
        type === "KB"
          ? {
              tableUUId: tableUUId,
              emailId: currentUser?.emailID,
              siteId: siteID,
              driveId: driveId,
              orgId: currentUser?.orgId,
              folderName: name,
              type: type,
              referenceId: referenceId,
              integration: source,
            }
          : {
              assistantId: uuid,
              contextId: instanceId,
              emailId: currentUser?.emailID,
              siteId: siteID,
              driveId: driveId,
              orgId: currentUser?.orgId,
              folderName: name,
              type: type,
              integration: source,
            };
      await axios.post(
        `${process.env.REACT_APP_INFINIIT_BASE_URL}/teams-channel-api/registerOneDriveChangeWebhook`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Folder successfully registered!");
      setShowModal(false);
      setShowOneDrive(false);
      type === "KB" ? fetchFolderName(tableUUId) : fetchFolderName();
      setLoadingData(false);
    } catch (error) {
      setLoadingData(false);

      console.error("Error registering webhook:", error);
      toast.error("Failed to register webhook.");
    }
  };

  return (
    <div className="p-4">
      <Fileopenmodal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setShowSharePoint(false);
        }}
        rootItems={rootItems}
        fetchFolderContent={fetchFolderContent}
        folderContent={folderContent}
        selectedFolderId={selectedFolderId}
        setShowOneDrive={setShowOneDrive}
        registerWebhook={registerWebhook}
        userEmail={email}
        siteID={id}
        driveId={driveId}
        source={source}
        fetchSharePointSites={fetchSharePointSites}
        fetchSharePointFolderChildren={fetchSharePointFolderChildren}
        loadingData={loadingData}
        fetchSharePointFolderFiles={fetchSharePointFolderFiles}
      />
    </div>
  );
};

export default OneDriveLogin;
